<template>
  <div class="page-position is-marginless column is-12 columns">
    <div class="column has-background-transparent pointer"
        @click="$emit('close')">
    </div>
    <div  class="has-background-white column is-5">
      <div class="section">
        <div class="level">
            <div class="level-left">
              <div class="subtitle is-4 has-test-link">Prévisualisation</div>
            </div>
            <!-- <div class="level-right">
                <b-button @click="$emit('accessParam')">
                  Paramétrage édition
                </b-button>
            </div> -->
        </div>
        <div class="content is-relative">
          <PDFJSViewer :fileName="link"/>
        </div>
        <div class="level mb-20 is-relative">
          <div class="level-left">
            <div class="level-item">
              <b-button @click="$emit('close')">
                <p class="is-size-14px">
                  Fermer
                </p>
              </b-button>
            </div>
          </div>
          <div class="level-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import PDFJSViewer from './PDFJSViewer';

const Panier = createNamespacedHelpers('panier');

export default {
  components: {
    PDFJSViewer,
  },
  props: {
    userEmail: String,
    opportunite: Object,
  },
  data() {
    return {
      link: '',
    };
  },
  methods: {
    ...Panier.mapActions({
      actionsPrevisualiserOpportunite: 'previsualiserOpportunite',
    }),
    async previsualiserOpportunite() {
      if (this.opportunite.produits.panneauxLc.length !== 0 ||
        this.opportunite.produits.reseauxTempo.length !== 0 ||
        this.opportunite.produits.reseauxLc.length !== 0 ||
        this.opportunite.produits.panneauxNumeriques.length !== 0 ||
        this.opportunite.produits.reseauxNumeriques.length !== 0 ||
        this.opportunite.produits.reseauxPersonnalise.length !== 0) {
        const loadingComponent = this.$buefy.loading.open({ container: null });
        try {
          const res = await this.actionsPrevisualiserOpportunite();
          this.link = window.URL.createObjectURL(res.data);
          loadingComponent.close();
        } catch (e) {
          gestionErreur('Erreur lors de la prévisualisation de l\'opportunité', e);
          loadingComponent.close();
        }
      } else {
        gestionErreur('Aucun produit dans votre panier');
      }
    },
  },
  async mounted() {
    await this.previsualiserOpportunite();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/previsualiserOpportunite/modalPrevision.vue